import React, { Component } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux';
import { Document } from 'react-pdf'


import {
    exibirDocumento
} from '../../actions'

class DocumentScreen extends Component {

    constructor(){
        super()
    }

    componentWillMount(){
        this.props.exibirDocumento(this.props.match.params.id)
    }

    render() {
        var { exibir_doc, exibir_doc_load } = this.props.documentos
        var file = undefined
        var fileURL = undefined
        
        if(exibir_doc != undefined){
            file = new Blob([exibir_doc], {type: 'application/pdf'})
            fileURL = URL.createObjectURL(file)    
        }

        return (
            <div style={customStyles.container}>
                <div className="modal-header" style={customStyles.header}>
                    <div className="modal-title" id="exampleModalLabel" style={customStyles.text}>Visualizar Documento</div>
                    <button type="button" className="btn" onClick={ () => window.open('/assinatura','_blank')}>
                        <div className="modal-title" style={customStyles.text}>Assinar</div>
                    </button>
                </div>
                {file != undefined
                    ?<embed style={customStyles.framePDF} src={fileURL} type='application/pdf' name="SamplePdf"> 
                    </embed>
                    :<div className="d-flex justify-content-center">
                        {exibir_doc_load
                            ?<div className="spinner-border" role="status" style={{margin:'1%'}}>
                                
                            </div>
                            :'Nenhum arquivo PDF encontrado.'
                        }
                    </div>
                }
            </div>
        )
    }
}


const mapStateToProps = ({ documentos }) => {
    return {
        documentos
    }
}

export default connect(mapStateToProps, {
    exibirDocumento
})(DocumentScreen);

const customStyles = {
    framePDF: {
        width:'100%',
        height:'100%',
        padding:'2%'
    },
    container: {
        width:'100%',
        height:'100%',
    },
    text: {
        fontSize: 'x-large',
        fontWeight: '500',
        color:'white'
    },
    header: {
        background:'#343a40',
        alignItems:'center',
        color:'white',
        maxHeight: '54px',
        borderRadius:0
    }
}